import axios from 'axios';

const findAlmanacBuyerSubscription = async (dashboardId: string) => {
  const config = {
    url: `/external/dash/${dashboardId}/almanac/buyer_subscription`,
    method: 'get' as const,
  };

  const { data } = await axios.request<{ id: string }>(config);
  return data;
};

export default findAlmanacBuyerSubscription;
